import { type TransactionSummaryDTO, useIntl } from '@capsicum/common';
import { useRouter } from '@capsicum/common-web';
import { useUserTransactionHistorySummaryLast } from '@capsicum/features/wallet/shared';

import { TransactionCard } from '../../../ui';
import { SectionCardListWrapper, SectionTitle, SectionWrapper } from '../WalletPartnerDetails.styled';

type TransactionHistorySectionProps = {
	currencyId: string;
	partnerLogo?: string;
};

export const TransactionHistorySection = ({ currencyId, partnerLogo }: TransactionHistorySectionProps) => {
	const { $t } = useIntl();
	const { push } = useRouter();

	const { data } = useUserTransactionHistorySummaryLast({
		'currencyIds[]': [currencyId],
		orderBy: 'pendingForUser',
		type: 'fan_token'
	});

	const goToTransactionDetails = (transaction: TransactionSummaryDTO) => {
		push(`/wallet/transaction-details/${transaction.transactionId}`);
	};

	return (
		<SectionWrapper>
			<SectionTitle>{$t('wallet.partnerWallet.transactionHistory.title')}</SectionTitle>
			<SectionCardListWrapper>
				{data?.map(item => {
					return (
						<TransactionCard
							key={`transaction-${item.transactionId}`}
							{...item}
							partnerLogoUrl={partnerLogo}
							onClick={() => goToTransactionDetails(item)}
						/>
					);
				})}
			</SectionCardListWrapper>
		</SectionWrapper>
	);
};
